import React, {useEffect, useState} from 'react';
import axios from "axios";
import {API_BASE_URL} from "../../config";
import {toast} from "react-toastify";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loading from "../../components/Loading";
import {formatChf} from "../../utils/currencyUtils";

const ReportingClients = () => {
    const [customersOrders, setCustomersOrders] = useState({orders: [], orders_total: null});
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState({
        start: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), // il y a 30j
        end: new Date()
    });

    useEffect(() => {
        if (!date.start || !date.end) return;

        setLoading(true);
        axios.post(`${API_BASE_URL}/reporting/orders/positives/`, {
            start: date.start.toISOString().slice(0, 10), end: date.end.toISOString().slice(0, 10)
        })
            .then((res) => {
                if (res.data) {
                    console.log(res.data)
                    const orders = res.data;
                    const orders_total = orders.reduce((acc, curr) => acc + (curr.total_net || 0), 0);

                    console.log(orders.length)
                    setCustomersOrders({orders, orders_total});
                } else {
                    setCustomersOrders([]);
                }
                setLoading(false);
            })
            .catch(err => {
                toast.error("Une erreur est survenue lors de la récupération des commandes.");
                console.error('Error fetching orders:', err);
            });
    }, [date.start, date.end]);

    return (<div>
            <h2 className={"color-third"}>Commandes client</h2>

            <div style={{display: 'flex', gap: '1rem', marginBottom: '1rem'}}>
                <div>
                    <label>Date de début</label>
                    <DatePicker
                        locale="fr"
                        selected={date.start}
                        onChange={(dateValue) => setDate(prev => ({...prev, start: dateValue}))}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Début"
                        className="form-control"
                        calendarStartDay={1} // Monday as the first day of the week
                    />
                </div>

                <div>
                    <label>Date de fin</label>
                    <DatePicker
                        locale="fr"
                        selected={date.end}
                        onChange={(dateValue) => setDate(prev => ({...prev, end: dateValue}))}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Fin"
                        className="form-control"
                        calendarStartDay={1} // Monday as the first day of the week
                    />
                </div>
            </div>

            <h3 className={"color-third mr-10"}>Panier moyen</h3>
        { formatChf (customersOrders.orders_total / customersOrders.orders.length)}
            <h3 className={"color-third mr-10"}>Acquisition</h3>

            {loading ? <Loading/> :
                <div>
                    <h4>Résultat</h4>

                    {customersOrders.orders.map((order) => (
                        <span>{formatChf( order.total_net)}<br/></span>
                    ))}
                </div>
            }
        </div>);
};

export default ReportingClients;
